import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import {
  buildCheckboxInput,
  buildMappingSelectInput,
  buildNumberInput,
  buildSelectInput, buildTextArea,
  buildTextInput
} from './form-inputs';
import _ from 'lodash';
import moment from 'moment';

const EditLiftoffMappingButton = ({entity, title, fields, mappingData, onComplete, style, disabled, psa_instance}) => {
  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();
  const formFields = fields.map(f => f.field);

  useEffect(() => {
    formFields.forEach(f => {
      if (entity[f]) {
        const field = _.find(fields, {field: f});

        if (field.type === 'mapping') {
          if (field.multi) {
            form.setFieldValue(f, entity[f].map(v => v.ID));
          } else {
            form.setFieldValue(f, entity[f] ? entity[f].ID : null);
          } 
        } else if (field.type === 'date') {
          form.setFieldValue(f, moment(entity[f]));
        } else {
          form.setFieldValue(f, entity[f]);
        }
      }
    }); 
  }, [entity, fields, form, formFields, mappingData]);

  const cancel = () => {
    form.resetFields(formFields);
    setShowModal(false);
  };

  const submit = async () => {
    const completedForm = {ID: entity.ID};
    formFields.forEach(f => {
      completedForm[f] = form.getFieldValue(f);
    });
    if (psa_instance) {
      completedForm['PsaInstance'] = psa_instance;
    }

    onComplete(completedForm);
    setShowModal(false);
    form.resetFields();
  };

  return (
    <>
      <Button onClick={() => setShowModal(true)} icon={<EditOutlined/>} style={style} disabled={disabled}>
        Edit
      </Button>

      <Form name={title} form={form} onFinish={submit} labelCol={{span: 7}} style={{display: 'none'}}>
        {showModal && (
          <Modal
            title={`Edit ${title} ${psa_instance ? `(${psa_instance})` : ''}`}
            width={700}
            open={showModal}
            onCancel={cancel}
            footer={[
              <Button key="cancel" onClick={cancel}>Cancel</Button>,
              <Button key="submit" type="primary" onClick={() => form.submit()}>
                Save
              </Button>
            ]}
          >
            {fields.map(f => {
              switch (f.type) {
                case 'text':
                  return buildTextInput(f);
                case 'textarea':
                  return buildTextArea(f);
                case 'number':
                  return buildNumberInput(f);
                case 'checkbox':
                  return buildCheckboxInput(f);
                case 'select':
                  return buildSelectInput(f, false);
                case 'multiselect':
                  return buildSelectInput(f, true);
                case 'mapping':
                  return buildMappingSelectInput(mappingData, f, psa_instance);
                default:
                  return <></>;
              }
            })}
          </Modal>
        )}
      </Form>
    </>
  );
};

export { EditLiftoffMappingButton };